document.addEventListener('click', (e) => {
    let target = e.target;

    if ( target.classList.contains('accordion-title') ) {
        //console.log('Accordion clicked', target );

        const selected_accordion = target.closest('.accordion-wrapper');
        const accordion_parent = target.closest('.accordion-category');
        const sibling_accordions = accordion_parent.querySelectorAll('.accordion-wrapper');
        
        

        //console.log('Accordion parent', accordion_parent);

        // IF already active - Close
        if ( selected_accordion.classList.contains('active') ) {
            selected_accordion.classList.remove('active');
        } else {
            if (accordion_parent) {
                // Close sibling accordions 
                if (sibling_accordions) {
                    sibling_accordions.forEach( accordion => {
                        accordion.classList.remove('active');
                    });
                }
            }
            
            // Activate Selected Accordion
            selected_accordion.classList.add('active');
        }

    }
});